





































































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { Subscription } from '@/core/ApiTypes'
import appManager from '@/services/AppManager'

@Component
export default class EditLicenseCountDialog extends Vue {
    @Prop()
    value: boolean|undefined // true to show the dialog
    @Prop()
    onCloseRequested: (() => void)|undefined
    @Prop()
    subscription: Subscription|undefined
    @Prop()
    assignedUsersCount: number|undefined
    newLicenseCountText: string|null = ''
    isConfirmVisible: boolean = false
    isUpdating: boolean = false
    formErrorMessage: string|null = null

    getAssignedUserCount(): number {
        return this.assignedUsersCount || 0
    }

    getSubscriptionQuantity(): number {
        return this.subscription?.data?.quantity || 0
    }

    getNewLicenseCount(): number {
        const newCountText = (this.newLicenseCountText || '').trim()
        return +newCountText
    }

    onCancelPressed() {
        if (this.onCloseRequested)
            this.onCloseRequested()
    }

    onApplyPressed() {
        const newCount = this.getNewLicenseCount()
        if (!Number.isFinite(newCount)) {
            this.formErrorMessage = 'Please enter a valid number'
            return
        }
        if (!Number.isInteger(newCount) || newCount < 1) {
            this.formErrorMessage = 'Please enter a whole number count'
            return
        }
        if (newCount < this.getAssignedUserCount()) {
            this.formErrorMessage = 'Count must be greater than or equal to the number of actively assigned users to this subscription'
            return
        }
        if (newCount === this.getSubscriptionQuantity()) {
            this.formErrorMessage = 'Must specify a count which differs from the current license count'
            return
        }

        this.formErrorMessage = null
        this.isConfirmVisible = true
    }

    async onConfirmCountPressed() {
        if (!this.subscription)
            return

        this.isUpdating = true

        try {
            await appManager.subscriptionManager.editSubscriptionQuantity({
                stripeCustomerId: this.subscription.data.stripeCustomerId,
                stripeSubscriptionId: this.subscription.id,
                stripeSubscriptionItemId: this.subscription.data.stripeSubscriptionItemId,
                quantity: this.getNewLicenseCount()
            })

            if (this.onCloseRequested)
                this.onCloseRequested()

            appManager.alertManager.publishSuccess('Subscription licenses successfully changed')
        } catch (error) {
            console.error(`Error Editing Subscription Quantity: ${error}`)
            this.formErrorMessage = 'Sorry there was an error. Please try again later.'
        }

        this.isUpdating = false
        this.isConfirmVisible = false
    }
}
